




































import Vue from 'vue';

export default Vue.extend({
    name: 'us-payment-restriction-modal',

    props: {
        ctaOpts: {
            type: Object,
            required: true,
            default: () => ({
                text: '',
                callback: null,
            }),
        },
    },

    methods: {
        onClickCta(): void {
            if (this.ctaOpts.callback) {
                this.ctaOpts.callback();
            }
        },
    },
});
